import React from "react"
import Fade from "react-reveal/Fade"
import data from "../yourdata"

import reactIcon from "../images/react-native.svg"
import gatsbyIcon from "../images/gatsbyjs.svg"
import firebaseIcon from "../images/firebase.svg"




const Footer = () => {


  return (
    <div className="section" id="contact" style={{marginTop:"2rem", marginBottom: "2rem"}}>
      <div className="container">
        <div className="footer-container">
          <Fade bottom cascade>
            <h1>Thank You!</h1>
            <p>Powered By <a href="https://reactjs.org/docs/getting-started.html"><img style={{width: '25px'}} src={reactIcon} alt="css"></img></a>  
            <a href="https://www.gatsbyjs.com/"><img src={gatsbyIcon} style={{width: '25px'}} alt="css"></img></a> 
            <a href="https://firebase.google.com/"><img  style={{width: '25px'}}src={firebaseIcon} alt="css"></img></a> </p>
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default Footer
